<template>
    <div class="d-flex flex-column h-100" @wheel="mouseWheel">
        <div>
            <particles v-if="$route.meta.bgeffect" :background="$route.meta.bgeffect" :key="$root.keyparticles"></particles>

            <div class="container-fluid p-0">
                <navigation v-if="showMenu" @hideNavigation="hideNavigation()" @refreshServices="refreshServices()"></navigation>

                <div id="content" v-show="!showMenu">
                    <topheader @showNavigation="showNavigation()"></topheader>

                    <div id="content-view">
                        <transition :enter-active-class="$root.routerViewAnimateEnter" 
                                    :leave-active-class="$root.routerViewAnimateLeave"
                                    @after-enter="afterEnter"
                                    mode="out-in">
                            <router-view @goToService="goToService"/>
                        </transition>
                    </div>

                    <navcircles></navcircles>
                </div>
            </div>
        </div>

        <footer class="mt-auto" >
            <div class="row" id="footer-builtoverinnovation" v-if="showMenu">
                <div class="col-xl-5 d-none d-xl-block px-0"></div>

                <div class="col-xl-7 col-12 p-xl-0 p-0 pl-4 text-red">
                    BUILT OVER INNOVATION
                </div>
            </div>


            <div class="row">
                <div class="col-xl-5 d-none d-xl-block px-0" id="footer-contacts">
                    <div class="row h-100">
                        <div class="col-xl-6">
                            <i id="circle-contact" class="far fa-envelope"></i>
                            <small class="link" @click="$root.clickLink('contatti')">{{ $t("contacts") }}</small>  
                        </div>

                        <div class="col-xl-6 bg-gray opacity-0" v-if="$route.name == 'case-studies'"></div>
                    </div>
                </div>

                <div class="col-xl-7 col-12 p-xl-0 p-0 pl-4 text-white">
                    <div class="row bg-black" id="footer-black">
                        <div class="col-6 footer-biswiss">
                            <span>BISWISS</span>
                        </div>

                        <div class="col-6 text-right footer-biswiss">
                            <small :class="[{'font-weight-bold': $root.getLanguage() == 'it'}, {'link': $root.getLanguage() !== 'it'}]" @click="chageLocale('it')">IT</small>
                            <small :class="['ml-1', {'font-weight-bold': $root.getLanguage() == 'en'}, {'link': $root.getLanguage() !== 'en'}]" @click="chageLocale('en')">EN</small>


                            <!--<small class="mr-4">{{ $t("privacy") }}</small>
                            <small>{{ $t("credits") }}</small>-->
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import particles from './particles';
import navigation from './navigation';
import topheader from './topheader';
import navcircles from './navcircles';

export default {
    name: 'website',

    components: {
        "particles": particles,
        "navigation": navigation,
        "topheader": topheader,
        "navcircles": navcircles
    },

    data() {
        return {
            showMenu: false,
            wheelScroll: true
        }
    },

    mounted() {
        this.$root.animejs({
            targets: '#content, #logo-header, footer',
            opacity: [0,1],
            easing: "easeInOutQuad",
            duration: 500
        });

        var thisObj = this;
        $(document).on('keydown', function(e) {
            var code = (e.keyCode ? e.keyCode : e.which);
            switch (code){
                case 40:
                    //Down pressed
                    e.deltaY = 1;
                    thisObj.mouseWheel(e);
                    break;
                case 38:
                    //Up pressed
                    e.deltaY = -1;
                    thisObj.mouseWheel(e);
                    break;
            }
        });
    },

    methods: {
        showNavigation() {
            var thisObj = this;
            this.$root.animejs({
                targets: '#content',
                opacity: 0,
                easing: "easeOutExpo",
                duration: 200,
                complete: function(anim) {
                    thisObj.showMenu = true;
                }
            });
        },

        hideNavigation() {
            var thisObj = this;
            this.$root.animejs({
                targets: 'footer #footer-builtoverinnovation',
                opacity: 0,
                easing: "easeOutExpo",
                duration: 200,
                complete: function(anim) {
                    thisObj.showMenu = false;
                }
            });
            
            this.$root.animejs.timeline({loop: false})
            .add({
                targets: '#navigation',
                opacity: 0,
                easing: "easeOutExpo",
                duration: 200
            })
            .add({
                targets: '#content, footer #footer-contacts, footer .footer-biswiss',
                opacity: [0,1],
                easing: "easeInOutQuad",
                duration: 200
            })
            .add({
                targets: 'footer #footer-black',
                height: '70px',
                easing: "easeInOutQuad",
                duration: 200
            }, '-=250');
        },

        mouseWheel(event) {
            if(this.wheelScroll) {
                if(!(this.$route.name == "case-studies" && $(event.target).closest("#project-body").length)) {
                    var scrollbarShow = $("body").css("overflow");

                    if(!this.showMenu && scrollbarShow == "hidden") {
                        var routeName = this.$route.name;
                        var routePrev = null;
                        var routeNext = null;

                        var menuitems = this.$root.menuitems;
                        $.each(menuitems, function(index, value) {
                            if(value.name === routeName) {
                                routePrev = index === 0 ? null : menuitems[index - 1].name;
                                routeNext = index === (menuitems.length - 1) ? null : menuitems[index + 1].name;
                            }
                        });

                        var newRoute = event.deltaY > 0 ? routeNext : routePrev;
                        if(newRoute) {
                            this.$root.setTransitionRouterView(newRoute);
                            this.$router.push({name: newRoute});
                            this.$root.changeRouteView();
                        }
                    }

                    this.wheelScroll = false;
                }
            }
        },

        refreshServices() {
            this.$emit("refreshServices");
        },

        goToService(idService) {
            this.$root.idObject = idService;
            this.$root.setTransitionRouterView("servizi");
            this.$router.push({name: "servizi"});
            this.$root.changeRouteView();
        },

        afterEnter() {
            this.wheelScroll = true;
        },

        chageLocale(locale) {
            if(this.$root.getLanguage() !== locale) {
                this.$i18n.locale = locale;
                this.$root.keyApplication += 1;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website.vue